import { AnimatePresence, motion } from 'framer-motion';
import React, { FC, useState, useContext } from 'react';
import {
  DataLayerContext,
  DataLayerContextType,
} from '../../providers/data-layer/data-layer.provider';
import GtmEventNameEnum from '../../../models/gtm-event-name-enum';
import { MyDetailsFormType } from '../../../models/my-details-form-type';
import FormSuccessBlock from '../../molecules/form-success-block/form-sucess-block';
import UpdateDetailsForm from '../../molecules/update-details-form/update-details-form';
import UpdatePasswordForm from '../../molecules/update-password-form/update-password-form';

const MyDetailsForm: FC<MyDetailsFormType> = (props: MyDetailsFormType) => {
  const { pushToDataLayer } =
    useContext<DataLayerContextType>(DataLayerContext);
  const [showSuccess, setShowSuccess] = useState<boolean>(null);

  const handleFormSuccessDataLayer = () => {
    pushToDataLayer(GtmEventNameEnum.DetailsUpdate);
  };

  return (
    <div className="py-component-spacing-mobile lg:py-component-spacing">
      <AnimatePresence>
        {showSuccess && (
          <motion.div className="mx-auto lg:ml-20">
            <FormSuccessBlock
              heading="Your changes have been saved"
              message="This page will reload in 10 seconds and take you back to your details"
              redirectSeconds={10}
              onRedirect={() => setShowSuccess(false)}
            />
          </motion.div>
        )}
      </AnimatePresence>

      <AnimatePresence>
        {!showSuccess && (
          <motion.div
            animate={{ opacity: 1 }}
            className="flex flex-col space-y-5 mx-auto lg:ml-20 w-full md:w-96"
            initial={{ opacity: showSuccess === null ? 1 : 0 }}
          >
            <UpdateDetailsForm
              {...props}
              onSuccess={() => {
                window.scrollTo({ top: 0 });
                setShowSuccess(true);
                handleFormSuccessDataLayer();
              }}
            />

            <UpdatePasswordForm
              {...props}
              onSuccess={() => {
                window.scrollTo({ top: 0 });
                setShowSuccess(true);
                handleFormSuccessDataLayer();
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MyDetailsForm;
